import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts a file size to a human readable format.
 *
 * Usage: `{{ file.size | fileSize }}`
 */
@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
  private units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

  transform(bytes: number = 0, precision: number = 2): string {
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
      return '';
    }

    let unit = 0;

    while (bytes >= 1024 && unit < this.units.length - 1) {
      bytes /= 1024;
      unit++;
    }

    if (unit) {
      return `${bytes.toFixed(precision)} ${this.units[unit]}`;
    }
    return `${bytes} ${this.units[unit]}`;
  }
}
